export default class Stats {
  constructor({
    overallStats = {},
    monthlyStats = {},
  }) {
    this.overallStats = overallStats
    this.monthlyStats = monthlyStats
  }
}
